var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployees({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clone page",
    clipPath: "url(#clip0_59_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2944,
    transform: "translate(-120 -1101)",
    fill: "#FFFBFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inquiry author info"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -224.5,
    width: 399,
    height: 474,
    rx: 19.5,
    stroke: "black",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip1_59_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 6.125C13.5509 6.125 14.8125 4.8634 14.8125 3.3125C14.8125 1.7616 13.5509 0.5 12 0.5C10.4491 0.5 9.1875 1.7616 9.1875 3.3125C9.1875 4.8634 10.4491 6.125 12 6.125ZM12 2.375C12.5169 2.375 12.9375 2.79559 12.9375 3.3125C12.9375 3.82941 12.5169 4.25 12 4.25C11.4831 4.25 11.0625 3.82941 11.0625 3.3125C11.0625 2.79559 11.4831 2.375 12 2.375ZM4.6875 8C6.2384 8 7.5 6.7384 7.5 5.1875C7.5 3.6366 6.2384 2.375 4.6875 2.375C3.1366 2.375 1.875 3.6366 1.875 5.1875C1.875 6.7384 3.1366 8 4.6875 8ZM4.6875 4.25C5.20441 4.25 5.625 4.67059 5.625 5.1875C5.625 5.70441 5.20441 6.125 4.6875 6.125C4.17059 6.125 3.75 5.70441 3.75 5.1875C3.75 4.67059 4.17059 4.25 4.6875 4.25ZM19.3125 8C20.8634 8 22.125 6.7384 22.125 5.1875C22.125 3.6366 20.8634 2.375 19.3125 2.375C17.7616 2.375 16.5 3.6366 16.5 5.1875C16.5 6.7384 17.7616 8 19.3125 8ZM19.3125 4.25C19.8294 4.25 20.25 4.67059 20.25 5.1875C20.25 5.70441 19.8294 6.125 19.3125 6.125C18.7956 6.125 18.375 5.70441 18.375 5.1875C18.375 4.67059 18.7956 4.25 19.3125 4.25ZM24 11.7031V18.6406H22.125V24.5H20.25V16.7656H22.125V11.7031C22.125 11.1862 21.7044 10.7656 21.1875 10.7656H17.4375C17.3406 10.7656 17.2462 10.7806 17.1562 10.8088V16.7656H18.375V24.5H16.5V18.6406H14.8125V24.5H12.9375V16.7656H15.2812V9.82812C15.2812 9.31122 14.8607 8.89062 14.3438 8.89062H9.60938C9.09247 8.89062 8.67188 9.31122 8.67188 9.82812V16.7656H11.0625V24.5H9.1875V18.6406H7.5V24.5H5.625V16.7656H6.79688V10.7957C6.72107 10.7761 6.64252 10.7656 6.5625 10.7656H2.8125C2.29559 10.7656 1.875 11.1862 1.875 11.7031V16.7656H3.75V24.5H1.875V18.6406H0V11.7031C0 10.1522 1.2616 8.89062 2.8125 8.89062H6.5625C6.69269 8.89062 6.82178 8.89996 6.94904 8.91736C7.32843 7.81232 8.37726 7.01562 9.60938 7.01562H14.3438C15.5782 7.01562 16.6285 7.81543 17.0061 8.92358C17.1476 8.90198 17.2917 8.89062 17.4375 8.89062H21.1875C22.7384 8.89062 24 10.1522 24 11.7031Z",
    fill: "#4D2481"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2944,
    fill: "white",
    transform: "translate(-120 -1101)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_59_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.a7e21ada2f0b971b72b4f05a165c22a4.svg";
export { ForwardRef as ReactComponent };